import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderKempVideos extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
    }

    getItemHtml(item, relatedMedia) {
        const img  = 'https://kemptechnologies.com/images/kemptechnologieslibraries/banners/generic-video-thumb-woman.jpg';
        if(item.ListImage.length > 0) {
            img = item.ListImage[0].Url
        }

        const { Title, Summary, UrlName: resourcePath } = item;
        const pageUrl = super.getResourceUrl(item.contenttypes[0]);
        const resourceUrl = `${pageUrl}/${resourcePath}`.replace('/details/', '/');

        const html = `
        <div class="col-4 -l-half">
            <div class="Card Elevated -h-scale">
                <img src="${img}"/>
                <div>
                    <h4>
                        <a href="${resourceUrl}" class="HoverBox">${this.encodeHtml(Title)}</a>
                    </h4>
                    <p class="-fs15 -mb0">${Summary}…</p>
                </div>
            </div>
        </div>
    `;
            return html;
    }
}
